import BookSlotForm from "../BookSlotForm";

import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./BookSingleConsultationForm.module.scss";

interface BookSingleConsultationFormProps {
  standalone?: boolean;
}

const BookSingleConsultationForm: React.FC<BookSingleConsultationFormProps> = ({
  standalone,
}) => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const prefix = "";
  const title = `Buy a 3-month personalised nutrition plan for just ${data?.packData?.currencySymbol}&nbsp;${data?.packData?.price}`;

  return (
    <div
      className={clsx(
        cls("bookSingleConsultationForm"),
        standalone ? cls("standalone") : ""
      )}
    >
      <div className={cls("bookSingleConsultationFormWrapper")}>
        <div className={cls("header")}>
          <Typography
            variant="paragraph1"
            className={cls("prefix")}
            dangerouslySetInnerHTML={{ __html: prefix }}
          />
          {data?.packData?.currencySymbol && data?.packData?.price !== null && <Typography
            variant="heading2"
            className={cls("title")}
            dangerouslySetInnerHTML={{ __html: title }}
          />}
        </div>
        <BookSlotForm
          showModal={{
            packageData: data?.packData,
          }}
        />
      </div>
    </div>
  );
};

export default BookSingleConsultationForm;
